import {
  BRAND_VALUE_FILTER_TYPE,
  buildFilterKey,
} from "@faire/deprecated-retailer-visitor-shared/filters/filterKeys";
import { useLoggedOutSuppliersPageCurrentCategory } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/Context/useLoggedOutSuppliersPageCurrentCategory";
import { useLoggedOutSuppliersPageQueryParams } from "@faire/deprecated-retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/QueryParams/useLoggedOutSuppliersPageQueryParams";
import { match } from "@faire/web-api--source/routes/www/suppliers/c1SuppliersUrlId/brand-value/brandValue/match";
import { isTupleOfLength } from "@faire/web/common/typescriptUtils";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export const useLoggedOutSuppliersPageFilterKeysQueryParams = () => {
  const categoryModel = useLoggedOutSuppliersPageCurrentCategory();
  const { queryParams, setQueryParams } =
    useLoggedOutSuppliersPageQueryParams();
  const { filters = [] } = queryParams;
  const { pathname } = useLocation();
  const brandValue = match(pathname)?.params.brandValue?.replace(/-/g, "_");

  const uniqueSortedFilterKeys = useMemo(() => {
    const normalizedFiltersQueryParams: string[] = [];
    if (categoryModel.isAllBrands && brandValue) {
      const brandValueFilterKey = buildFilterKey(
        BRAND_VALUE_FILTER_TYPE,
        brandValue
      );
      normalizedFiltersQueryParams.push(brandValueFilterKey);
    }
    // This is to support standard query params like `?filters=k1&filters=k2`
    if (filters && isTupleOfLength(filters, 1)) {
      normalizedFiltersQueryParams.push(...filters[0].split(","));
    }

    return uniqueAndSorted(normalizedFiltersQueryParams);
  }, [brandValue, categoryModel.isAllBrands, filters]);

  const setFilterKeys = (updater: (prevFilterKeys: string[]) => string[]) => {
    const updatedFilterKeys = uniqueAndSorted(updater(uniqueSortedFilterKeys));
    setQueryParams(() => ({
      filters:
        updatedFilterKeys.length === 0
          ? undefined
          : [updatedFilterKeys.join(",")],
    }));
  };

  return {
    filterKeys: uniqueSortedFilterKeys,
    setFilterKeys,
  };
};

const uniqueAndSorted = (arr: string[]) => [...new Set(arr)].sort();
